var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consult-page"},[_c('iframe',{staticStyle:{"width":"100%","min-height":"100%","border":"none"},attrs:{"src":"https://widget.figo.cn/chat-page?appId=fc_PQlur8Z8ziSfoNyfJhBR_Bhx","allow":"microphone","loading":"lazy"}})])
}]

export { render, staticRenderFns }